/**
 * Which deployment a Sentry event came from — one answer for web, the API and
 * realtime.
 *
 * A Vercel deployment is tagged `vercel-<VERCEL_ENV>`: `vercel-production`,
 * `vercel-preview`, `vercel-development`. That is the tag `@sentry/nextjs`
 * gives a Vercel deployment by itself, so it is what production has always been
 * filed under, and every filter and alert on the project is built on it.
 *
 * Anything else is `local`. In particular `NODE_ENV` is never consulted:
 * `next start` and a bundled server set `NODE_ENV=production` on a laptop too,
 * which is how a local e2e lane's server errors reached the feed tagged
 * `production` (THE-SUKHA-COMPANY-SZ, TX-5256).
 *
 * @param vercelEnv - `VERCEL_ENV` on a server, `NEXT_PUBLIC_VERCEL_ENV` in a
 *   browser bundle (only `NEXT_PUBLIC_` values are inlined there)
 */
export function sukhaSentryEnvironment(vercelEnv: string | undefined): string {
  const deployment = vercelEnv?.trim();
  return deployment ? `vercel-${deployment}` : LOCAL_SENTRY_ENVIRONMENT;
}

/** The environment of any process that is not a Vercel deployment. */
export const LOCAL_SENTRY_ENVIRONMENT = "local";
